import { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../lib/useApi";
import { AzureUnavailable, Button, EmptyState, ErrorState, Input, PageHeader, Spinner, Table, Td } from "../components/ui";

interface AzureProject {
  id: string | number;
  name?: string;
  org_name?: string;
  member_count?: number;
  created_at?: string;
  [key: string]: unknown;
}

export default function Projects() {
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const { data, loading, error, errorStatus, reload } = useApi<{ items: AzureProject[]; total: number }>(
    `/projects?search=${encodeURIComponent(query)}`,
  );

  return (
    <div>
      <PageHeader title="Projects" subtitle="Paid platform projects (tm_projects on Azure)" />

      <form
        className="mb-4 flex gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          setQuery(search);
        }}
      >
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search projects…" className="max-w-sm" />
        <Button type="submit" variant="secondary">
          Search
        </Button>
      </form>

      {loading ? (
        <Spinner />
      ) : error ? (
        errorStatus === 502 || errorStatus === 503 ? (
          <AzureUnavailable detail={error} />
        ) : (
          <ErrorState message={error} onRetry={reload} />
        )
      ) : !data || (data.items ?? []).length === 0 ? (
        <EmptyState message="No projects found." />
      ) : (
        <div className="rounded-lg border border-slate-200 bg-white shadow-sm">
          <Table headers={["Project", "Organisation", "Members", "Created"]}>
            {data.items.map((p) => (
              <tr key={String(p.id)} className="hover:bg-slate-50">
                <Td>
                  <Link to={`/projects/${p.id}`} className="font-medium text-rail-600 hover:underline">
                    {p.name ?? String(p.id)}
                  </Link>
                </Td>
                <Td>{p.org_name ?? "—"}</Td>
                <Td>{p.member_count ?? "—"}</Td>
                <Td className="text-xs">{p.created_at ? String(p.created_at) : "—"}</Td>
              </tr>
            ))}
          </Table>
        </div>
      )}
    </div>
  );
}
